import React from 'react';
import './LoadingSpinner.scss'; // Импортируем стили

export let LoadingSpinner = ({position}) => {
  return (
    <div className={`loading-spinner ${position}`}>
      <div className="spinner"></div>
    </div>
  );
};